import { Inject, Injectable } from '@angular/core';
import { deepCopy, DwCacheService, DwEventService, DwFormActionInterceptResult, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { KickoffEntity, KickoffMetaDataService, KickoffMetaData, EthosJobNumberEntity } from '../meta-data/kickoff-meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class KickoffDocumentRepositoryService {

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwEventsService: DwEventService,
    private dwCacheService: DwCacheService,
  ) { }

  getJobInformation(jobNumberId: number) : Observable<EthosJobNumberEntity> {

    const md = new KickoffMetaDataService();

    const qh = new DwQueryHelper();

    const query = KickoffMetaData.EthosJobNumber.CreateQuery();

    query.AddFilterAnd(qh.filters.Equal(KickoffMetaData.EthosJobNumber.JobNumberId, jobNumberId));    

    query.FieldSettings.LoadAllLookupDisplayFields = true;    

    return this.dwOrmDataService.executeQuerySingle(query);
  }

  saveKickoffDocuments(kickoffDocument: KickoffEntity, addedJobs: EthosJobNumberEntity[], newKickoffs: KickoffEntity[]) :Observable<KickoffEntity[]> {
    newKickoffs = [];
    addedJobs.forEach(jn => {
      let cloneKickoff = deepCopy(kickoffDocument);
      cloneKickoff.Ethos_JobNumberId = jn.JobNumberId;
      newKickoffs.push(cloneKickoff);
    })

    return this.dwOrmDataService.saveEntityCollection(newKickoffs, true);
  }
  
}
